import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

//import theme from '../../../theme';
//import { grey } from '@material-ui/core/colors';

import {Dialog, DialogActions, DialogContent, DialogTitle} from '@material-ui/core'
import {Container, Box, TextField, Button, FormControl, Checkbox} from '@material-ui/core'
//Typography, Paper
//import {ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails} from '@material-ui/core';
//import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { isInteger, isNumber } from '../../../api/validators';
//import { getObjectByID } from '../../../api/helpers';

/* settings fields:
AuthorizationRequired: false
Enabled: true
EndRtpPort: 37
Password: ""
Realm: null
ServerSipIP: "192.169.0.5"
ServerSipPort: 1234
StartRtpPort: 15
UserName: null
*/

class EditSipSettingsDialog_ extends React.Component{

    constructor(props){
        super(props)

        let settings = JSON.parse(JSON.stringify(this.props.settings))

        //defaults
        //console.log('EditSipSettingsDialog')
        //console.log(props)

        this.state = {
            settings: {...settings},
            errors:{
                ServerSipIP: false,
                ServerSipPort: false,
                StartRtpPort: false,
                EndRtpPort: false,
                Realm: false,
                UserName: false,
                Password: false,
            },
            changed: false,
        }

        this.handleInput = this.handleInput.bind(this)

        this.handleSave = this.handleSave.bind(this)
        this.handleClose = this.handleClose.bind(this)
    }

    handleSave(){
         console.log('handleSave')
        if(this.checkForm()){
            let settings = {...this.props.settings, ...this.state.settings}
            this.props.onAction({type: 'SIP_SETTINGS_EDITOR_SAVE', settings: settings})
        }else{
            this.props.onAction({type:'ALERT_DIALOG', message: this.props.t('CheckFormForErrors')})
        }
    }

    handleClose(){
        if(this.state.changed){
            this.props.onAction({
                type: 'CONFIRM_DIALOG', 
                message: this.props.t('CloseFormConfirm'),
                onConfirm: ()=>{
                    this.props.onAction({type: 'SIP_SETTINGS_EDITOR_CLOSE'})
                }
            })
        }else{
            this.props.onAction({type: 'SIP_SETTINGS_EDITOR_CLOSE'})
        }
    }

    handleInput(event){
        let changed = !this.state.changed ? {changed: true} : {}
        let val =  event.target.type==='checkbox' ? event.target.checked : event.target.value

        const err = this.validate(event.target.name, val)

        const settings = {...this.state.settings, [event.target.name]: val}

        const errors = {errors: {...this.state.errors, [event.target.name]: err}}
        //console.log('handleInput')
        //console.log(event.target.name)
        //console.log(errors)

        this.setState({settings: settings, ...changed, ...errors})
    }


    validate(name, value){
        const {t} = this.props
        let error = false

        switch(name){
            case 'ServerSipIP':
                break       

            case 'ServerSipPort':
            case 'StartRtpPort':
            case 'EndRtpPort':
                if(value && !isInteger(value)){
                    error = t('IsNotInteger')
                }
                break

            case 'Realm':
            case 'UserName':
            case 'Password':
                if(this.state.settings.AuthorizationRequired && !value){
                    error = t('ValueIsEmpty')
                }
                break

            default:
                console.log('Empty validator '+name)
        }

        return error
    }

    label(name){
        let {t} = this.props
        switch(name){
            default: return t(name)
        }
    }


    checkForm(){
        //console.log('checkform')
        //console.log(this.state.settings)
        //console.log(this.state.errors)
        let check = true
        let errors = {...this.state.errors}
        for(var i in errors){
            //console.log('check field '+i)
            let v = this.state.settings[i]
            let error = this.validate(i, v)
            errors[i] = error
            if(error) {
                console.error({field: i, value: v, error: error})
                check = false
            }
        }
        console.log(check + ' checkform')
        this.setState({errors: errors})
        return check
    }


    render(){
        const {t} = this.props

        const margin = {margin:'16px 0 8px 0'}


        return(
<Dialog
    scroll="body"
    fullWidth={this.props.fullWidth}
    maxWidth={this.props.maxWidth}
    open={this.props.open}
    onClose={this.handleClose}
    aria-labelledby="edit-dialog-title">
        
    <DialogTitle id="edit-dialog-title">{t('SipSettings')}</DialogTitle>
    <DialogContent>
        <form>
        <Container maxWidth="lg" style={{minWidth:550}}>

            <Box textAlign="left" style={{...margin, width: '100%'}}>
                    <FormControl>
                        <label>
                            <Checkbox color="primary" 
                                checked={this.state.settings.Enabled}
                                onChange={this.handleInput}
                                name="Enabled"
                                />
                                {t('EnableSipGateway')}
                        </label>
                    </FormControl>
            </Box>

            <Box textAlign="center">
                <TextField name="ServerSipIP"  margin="normal"
                    style={{width: '100%'}}
                    label={this.state.errors.ServerSipIP?this.state.errors.ServerSipIP:t('ServerSipIP')}
                    autoComplete="new-password"
                    error={this.state.errors.ServerSipIP!==false}
                    value={this.state.settings.ServerSipIP}
                    onChange={this.handleInput}
                />
            </Box>

            <Box textAlign="center">
                <TextField name="ServerSipPort"  margin="normal"
                    style={{width: '100%'}}
                    label={this.state.errors.ServerSipPort?this.state.errors.ServerSipPort:t('ServerSipPort')}
                    autoComplete="new-password"
                    error={this.state.errors.ServerSipPort!==false}
                    value={this.state.settings.ServerSipPort}
                    onChange={this.handleInput}
                />
            </Box>

            <Box textAlign="center">
                <TextField name="StartRtpPort"  margin="normal"
                    style={{width: '45%', marginRight:'5%'}}
                    label={t('RtpPortRange')} /* this.state.errors.StartRtpPort?this.state.errors.StartRtpPort:t('StartRtpPort')}*/
                    autoComplete="new-password"
                    error={this.state.errors.StartRtpPort!==false}
                    value={this.state.settings.StartRtpPort}
                    onChange={this.handleInput}
                />

                <TextField name="EndRtpPort"  margin="normal"
                    style={{width: '45%', marginLeft:'5%'}}
                    label={(' ')} /* EndRtpPort this.state.errors.EndRtpPort?this.state.errors.EndRtpPort:t('EndRtpPort')}*/
                    autoComplete="new-password"
                    error={this.state.errors.EndRtpPort!==false}
                    value={this.state.settings.EndRtpPort}
                    onChange={this.handleInput}
                />
            </Box>
            
            <Box textAlign="left" style={{...margin, width: '100%'}}>
                    <FormControl>
                        <label>
                            <Checkbox color="primary" 
                                checked={this.state.settings.AuthorizationRequired}
                                onChange={this.handleInput}
                                name="AuthorizationRequired"
                                />
                                {t('AuthenticationRequired')}
                        </label>
                    </FormControl>
            </Box>


            <Box textAlign="center">
                <TextField name="Realm"  margin="normal"
                    style={{width: '100%'}}
                    label={this.state.errors.Realm?t('Realm') + ': '+this.state.errors.Realm:t('Realm')}
                    autoComplete="new-password"
                    error={this.state.errors.Realm!==false}
                    value={this.state.settings.Realm}
                    onChange={this.handleInput}
                />
            </Box>

            
            <Box textAlign="center">
                <TextField name="UserName"  margin="normal"
                    style={{width: '100%'}}
                    label={this.state.errors.UserName?t('UserName') + ': '+this.state.errors.UserName:t('UserName')}
                    autoComplete="new-password"
                    error={this.state.errors.UserName!==false}
                    value={this.state.settings.UserName}
                    onChange={this.handleInput}
                />
            </Box>

            <Box textAlign="center">
                <TextField name="Password"  margin="normal"
                    type="password"
                    style={{width: '100%'}}
                    label={this.state.errors.Password?t('Password') + ': '+ this.state.errors.Password:t('Password')}
                    autoComplete="new-password"
                    error={this.state.errors.Password!==false}
                    value={this.state.settings.Password}
                    onChange={this.handleInput}
                />
            </Box>

        </Container>
        </form>
    </DialogContent>
    <DialogActions>
        <Button onClick={this.handleSave} variant="contained" color="primary">
            {t('Apply')}
        </Button>
        <Button onClick={this.handleClose} variant="contained" color="inherit">
            {t('Cancel')}
        </Button>
    </DialogActions>

</Dialog>
        );

    }
}

export const EditSipSettingsDialog = withTranslation()(EditSipSettingsDialog_);